import { useEffect, useState, useCallback } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import axios from "axios";
import { X } from "lucide-react";
import confetti from "canvas-confetti";
import { BadgePercent, Gift, Sparkles, Snowflake } from "lucide-react";
import { getStaticPricing, getProPricing } from '../../utils/pricingConfig';
import { PaymentGatewayRef } from './PaymentGateway';
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { connectWebSocket, disconnectWebSocket, listenToEvent } from "./webSocketService";

interface OfferModalProps {
  open: boolean;
  onClose: () => void;
  handleopenPricingModal: () => void;
  paymentGatewayRef?: React.RefObject<PaymentGatewayRef | null>;
  documentId?: string | null;
  userPlan?: string;
  exportPaid?: boolean;
  monthlyPlanId?: string;
  orgId?: string;
  authToken?:string;
  userEmail?:string;
  handleButtonClick?:()=>void;
  isGeneratedData:boolean

}
interface PaymentData {
  // Define the shape of the payment data based on your backend response
  [key: string]: any
}

interface SubscriptionData {
  // Define the shape of the subscription data based on your backend response
  [key: string]: any
}

export default function OfferModalNew({ 
  open, 
  onClose,
  handleopenPricingModal,
  paymentGatewayRef,
  documentId,
  userPlan,
  exportPaid,
  monthlyPlanId,
  orgId,
  authToken,
  userEmail,
   handleButtonClick,
  isGeneratedData=false
}: OfferModalProps) {
  const [currency, setCurrency] = useState("INR"); // Default currency is INR
  const [price, setPrice] = useState({ monthly: 500, monthlydiscounted: 250, annual: 5000, annualdiscounted: 2500 });
  const [loading,setIsLoading]=useState<boolean>(false)
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // Utility function to check if document ID has odd last digit
  const isDocumentIdOdd = (id: string | null | undefined): boolean => {
    if (!id) return false;
    const lastDigit = parseInt(id.charAt(id.length - 1));
    return !isNaN(lastDigit) && lastDigit % 2 === 1;
  };

  // Calculate time remaining until end of day
  const calculateTimeLeft = useCallback(() => {
    const now = new Date();
    const endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 999);
    
    const difference = endOfDay.getTime() - now.getTime();
    
    if (difference > 0) {
      setTimeLeft({
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      });
    } else {
      // If day has ended, reset to 24 hours
      setTimeLeft({
        hours: 24,
        minutes: 0,
        seconds: 0,
      });
    }
  }, []);
  const PricingPlans = useSelector((state: RootState) => state.razorpayPlans.plans);

  // Handle export button click
  const handleExportClick = async() => {
    // Check if document ID has odd last digit and trigger payment gateway directly
    // if ( userPlan === "free"  && paymentGatewayRef?.current) {
    //   paymentGatewayRef.current.triggerPayment({ amount: price.monthlydiscounted });
    //   onClose(); // Close the offer modal
    // } else {
    //   handleopenPricingModal();
    // }
    const DisountMonthyId =currency === 'INR'?PricingPlans[2]?.id:PricingPlans[1]?.id
    

        const planID = DisountMonthyId
        const currentTime = Date.now()
        const startAtTime = currentTime + 10 * 60 * 1000 // 10 minutes in milliseconds
        const startAtUnix = Math.floor(startAtTime / 1000) // Convert to Unix timestamp in seconds
    
        if (userPlan === 'free') {
          try {
            const response = await axios.post(
              `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/payments/razorpay/create-subscription`,
              {
                plan_id: planID,
                customer_id: orgId,
                total_count: 12,
                start_at: startAtUnix,
                quantity: 1,
                orgId: orgId,
                userId: userEmail,
                notes: {
                  OrgId: orgId,
                },
              },
              {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
              }
            )
    
            const result = await response.data

    
            if (result.short_url) {
              window.open(result.short_url, '_blank')
              setIsLoading(false)
            }
          } catch (error) {
            console.log(error)
            setIsLoading(false)
          }
        }
      }
  

      useEffect(() => {

        const changePaymentStatus=async()=>{
           try {
                    await fetch(
                      `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/slidedisplay/finalsheet/${documentId}`,
                      {
                        method: "PATCH",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: `Bearer ${authToken}`,
                        },
                        body: JSON.stringify({ paymentStatus:1, }),
                      }
                    );
                    console.log("Export status updated to true for odd documentId");
                  } catch (error) {
                    console.error("Error updating export status:", error);
                  }
        }
        if (!orgId) {
          console.error('orgId is required to connect WebSocket')
          return
        }
        let success=false;
    
        // Connect to WebSocket
        connectWebSocket(orgId)
    
        // Listen to payment authorization events
        listenToEvent('payment.authorized', (data: PaymentData) => {
          console.log('Payment authorized:', data)
          
        })
    
        // Listen to subscription events
        listenToEvent('subscription.authenticated', (data: SubscriptionData) => {
          console.log('Subscription authenticated:', data)
          if (isGeneratedData && handleButtonClick) {
            changePaymentStatus()
            handleButtonClick()
          }
           window.location.reload()
        })
    
        // Cleanup WebSocket on unmount
        return () => {
          disconnectWebSocket()
        }
      }, [orgId])

  // Timer effect - updates every second
  useEffect(() => {
    calculateTimeLeft(); // Calculate immediately when modal opens
    
    const timer = setInterval(calculateTimeLeft, 1000);
    
    return () => clearInterval(timer);
  }, [open]);

  useEffect(() => {
    const fetchCurrency = async () => {
      try {
        const response = await axios.get("https://api.zynth.ai/api/v1/data/userprofile/ip-info");
        const userCountry = response.data?.country;
        const resolvedCurrency = userCountry !== "IN" ? "USD" : "INR";

        setCurrency(resolvedCurrency);
        const pricing = getProPricing(resolvedCurrency);
        setPrice({ monthly: pricing.monthly, monthlydiscounted: pricing.monthlydiscounted, annual: pricing.annual, annualdiscounted: pricing.annualdiscounted });
      } catch (error) {
        console.error("Failed to fetch IP info:", error);
      }
    };

    fetchCurrency();
  }, []);

  useEffect(() => {
    if (open) {
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
      });
    }
  }, [open]);

  return (
    <Dialog.Root open={open} onOpenChange={() => {}} modal={true}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" style={{ zIndex: 9998 }} />
        <Dialog.Content
          className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
                     bg-gradient-to-br from-blue-50 via-cyan-50 to-blue-50
                     border-4 border-blue-500
                     p-4 sm:p-6 rounded-2xl shadow-2xl 
                     w-[90%] max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl 
                     text-center relative overflow-hidden z-50"
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 9999
          }}
        >
          {/* Decorative snowflakes */}
          <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden opacity-20">
            <Snowflake className="absolute top-4 left-4 text-blue-400 w-8 h-8 animate-spin" style={{ animationDuration: '10s' }} />
            <Snowflake className="absolute top-8 right-8 text-blue-300 w-6 h-6 animate-spin" style={{ animationDuration: '15s' }} />
            <Snowflake className="absolute bottom-12 left-12 text-blue-400 w-10 h-10 animate-spin" style={{ animationDuration: '12s' }} />
            <Snowflake className="absolute bottom-8 right-16 text-blue-300 w-7 h-7 animate-spin" style={{ animationDuration: '8s' }} />
          </div>

          <Dialog.Close className="absolute top-3 right-3 z-10 text-gray-600 hover:text-blue-600 transition-colors" onClick={onClose}>
            <X size={24} />
          </Dialog.Close>

          {/* Winter Holiday Banner */}
          <div className="mb-4 relative z-10">
            <div className="inline-block bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-6 py-2 rounded-full font-bold text-sm tracking-wider shadow-lg">
              ❄️ WINTER HOLIDAY SPECIAL ❄️
            </div>
          </div>

          <Dialog.Title
            className="text-xl sm:text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-cyan-600 to-blue-600 
                       animate-bounce flex items-center justify-center gap-2 relative z-10"
            style={{ animation: "bounce 1s ease infinite", animationIterationCount: 4 }}
          >
            <Snowflake className="text-blue-600 w-5 sm:w-6 h-5 sm:h-6 drop-shadow-lg" />
            <span>50% OFF</span>
            <Sparkles className="text-cyan-600 w-5 sm:w-6 h-5 sm:h-6 drop-shadow-lg" />
          </Dialog.Title>

          <p className="text-base sm:text-lg mt-2 font-semibold text-gray-700 relative z-10">
            ❄️ Exclusive Winter Holiday Sale!
          </p>

          <p className="text-base sm:text-lg mt-4 text-gray-700 relative z-10">
            <span className="text-lg sm:text-xl text-gray-500 line-through">
              {currency} - {price.monthly}
            </span>
            <span className="text-xl sm:text-2xl font-bold text-blue-700 ml-3 sm:ml-4">
              {currency} - {price.monthlydiscounted}
            </span>
          </p>
          
          {/* <p className="text-base sm:text-lg mt-4 text-gray-700 relative z-10">
            <span className="text-lg sm:text-xl text-gray-500 line-through">
              {currency} - {price.annual}
            </span>
            <span className="text-xl sm:text-2xl font-bold text-blue-700 ml-3 sm:ml-4">
              {currency} - {price.annualdiscounted}
            </span>
          </p> */}

          <p className="text-base sm:text-lg mt-3 sm:mt-4 relative z-10">
            ❄️ Limited time winter holiday offer to get unlimited access to Zynth AI tools.
          </p>

          <ul className="text-left text-gray-700 mt-4 space-y-3 sm:space-y-4 relative z-10">
            {[
              "Unlimited AI presentations.",
              "Unlimited AI documents",
              "Full access to Zynth Google Slides Add-on",
              "Free Powerpoint and Google Slides exports",
            ].map((feature, index) => (
              <li key={index} className="flex items-start gap-2">
                <svg
                  className="w-4 sm:w-5 h-4 sm:h-5 text-green-600 flex-shrink-0"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>{feature}</span>
              </li>
            ))}
          </ul>

          <button
            className="mt-5 sm:mt-6 px-4 sm:px-6 py-2 bg-gradient-to-r from-blue-600 to-cyan-600 text-white text-base sm:text-lg font-semibold rounded-full hover:from-blue-700 hover:to-cyan-700 transition transform hover:scale-105 shadow-xl relative z-10 border-2 border-white"
            onClick={handleExportClick}
          >
            ❄️ Get Winter Holiday Deal - Save 50% ❄️
          </button>

          {/* Countdown Timer */}
          <div className="mt-4 sm:mt-6 relative z-10">
            <p className="text-sm text-gray-600 mb-2">⏰ Offer Valid Until:</p>
            <div className="bg-gradient-to-r from-blue-100 to-cyan-100 border-2 border-blue-500 rounded-lg p-3 sm:p-4">
              <div className="flex justify-center items-center gap-2 sm:gap-3">
                <div className="text-center">
                  <div className="text-2xl sm:text-3xl font-bold text-blue-600 tabular-nums">
                    {String(timeLeft.hours).padStart(2, '0')}
                  </div>
                  <div className="text-xs sm:text-sm text-gray-600 font-semibold">Hours</div>
                </div>
                <div className="text-2xl sm:text-3xl font-bold text-gray-400">:</div>
                <div className="text-center">
                  <div className="text-2xl sm:text-3xl font-bold text-blue-600 tabular-nums">
                    {String(timeLeft.minutes).padStart(2, '0')}
                  </div>
                  <div className="text-xs sm:text-sm text-gray-600 font-semibold">Minutes</div>
                </div>
                <div className="text-2xl sm:text-3xl font-bold text-gray-400">:</div>
                <div className="text-center">
                  <div className="text-2xl sm:text-3xl font-bold text-blue-600 tabular-nums">
                    {String(timeLeft.seconds).padStart(2, '0')}
                  </div>
                  <div className="text-xs sm:text-sm text-gray-600 font-semibold">Seconds</div>
                </div>
              </div>
            </div>
          </div>

          <p className="text-sm text-gray-600 mt-3 relative z-10">
            ⏰ Limited time offer - Ends soon!
          </p>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}